export default __webpack_public_path__ + "static/media/01.c096969a.jpg";